import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

export default function Team() {
  const t = useT();
  const { TEAM } = useContent();

  return (
    <section data-testid="team-section" className="bg-white py-24 text-ink md:py-32">
      <div className="container-site">
        <Chapter n={5} label={t['ch.team']} dark />
        <FadeUp>
          <h2 className="max-w-2xl font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            {t['tm.h2a']} <span className="italic text-gold-dim">{t['tm.h2b']}</span>
          </h2>
        </FadeUp>
        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {TEAM.map((m, i) => (
            <FadeUp key={m.name} delay={i * 0.1}>
              <article data-testid={`team-card-${m.name.toLowerCase()}`} className="group">
                <div className="relative overflow-hidden rounded-xl" style={{ clipPath: 'inset(0 round 0.75rem)' }}>
                  <img src={m.img} alt={`${m.name}, ${m.role} — Reverence Services`} loading="lazy"
                    style={{ objectPosition: m.pos || 'center' }}
                    className="photo-treat aspect-[4/5] w-full object-cover grayscale transition-[filter,transform] duration-700 group-hover:scale-105 group-hover:grayscale-0" />
                  <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-700 group-hover:opacity-100"
                    style={{ background: 'radial-gradient(circle at 50% 30%, rgba(201,162,39,0.25), transparent 60%)' }} />
                  <span className="absolute bottom-4 right-4 rounded-sm bg-gold px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-widest text-ink">
                    {m.years} {t['tm.yrs']}
                  </span>
                </div>
                <h3 className="mt-5 font-serif text-2xl font-semibold">{m.name}</h3>
                <p className="text-sm font-bold text-gold-dim">{m.role}</p>
                <p className="mt-1 text-sm text-neutral-500">{m.specialty}</p>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
